import apiClient from './ApiInterceptor';
import { jwtDecode } from 'jwt-decode';

export const scheduleEvent = async (event, userId) => {
    try {
        if(!userId){
            const access_token = localStorage.getItem('access_token');
            const decodedToken = jwtDecode(access_token);
            userId = decodedToken.sub;
        }
        
        const jsonEvent = { ...event };
        
        if(typeof event.start_date !== 'string'){
            jsonEvent.start_date = `${event.start_date.format('YYYY-MM-DD')} ${event.start_date.format('HH:mm:ss')}`;
            jsonEvent.end_date = `${event.end_date.format('YYYY-MM-DD')} ${event.end_date.format('HH:mm:ss')}`;
        }

        const params = {
            event: jsonEvent,
            user_id: userId,
        };
        const response = await apiClient.post('/sessions/schedule', params);
        return { success: true, data: response.data };
    } catch (error) {
        console.error('SessionsApi - scheduleEvent, Error scheduling event:', error);
        return { success: false, error };
    }
};

export const checkAttendee = async (session_id, attended) => {
    try {
        const params = {
            session_id: session_id,
            attended: attended,
        };
        const response = await apiClient.post('/sessions/check_attendance', params);
        return { success: true, data: response.data };
    } catch (error) {
        console.error('SessionsApi - checkAttendee, Error checking attendance:', error);
        return { success: false, error };
    }
};

export const callCancelSession = async (sessionId) => {
    try {
        const response = await apiClient.post(`/sessions/${sessionId}/cancel`, {})
        return { success: true, data: response.data };
    } catch (error) {
        console.error('SessionsApi - cancelSession, Error cancelling session:', error);
        return { success: false, error };
    }
   
}

export const scheduleCourtesy = async (formData) => {
    try {
        // Clone formData to avoid mutating state
        const dataToSend = { ...formData };

        if (dataToSend.event) {
        // Format as local time string to resolve timezone issues
        if(typeof dataToSend.event.start_date !== 'string'){
            dataToSend.event.start_date = `${dataToSend.event.start_date.format('YYYY-MM-DD')} ${dataToSend.event.start_date.format('HH:mm:ss')}`;
        }
        if(typeof dataToSend.event.end_date !== 'string'){
            dataToSend.event.end_date = `${dataToSend.event.end_date.format('YYYY-MM-DD')} ${dataToSend.event.end_date.format('HH:mm:ss')}`;
        }
    }
        const response = await apiClient.post('/sessions/courtesy', dataToSend);
        return { success: true, data: response.data };
    } catch (error) {
        console.error('SessionsApi - scheduleCourtesy, Error scheduling courtesy:', error);
        return { success: false, error };
    }
}

export const fetchCourtesies = async (start_date, end_date) => {
    const params = {}
    if(start_date){
        params.start_date = start_date;
    }
    if(end_date){
        params.end_date = end_date
    }
    return await apiClient.get('/sessions/courtesies', { params });
};

export const fetchAttendedSessionsCount = async (user_id) => {
    const response = await apiClient.get(`/sessions/attended/${user_id}/count`);
    return response;
};
